import { Component } from "react"
import packageJson from '../../../package.json'

interface CopyRightState {
  buildVersion: string;
}

export default class CopyRight extends Component<{}, CopyRightState> {

  state: CopyRightState = {
    buildVersion: packageJson.version
  };

  componentDidMount() {
    fetch('build.json')
      .then((response) => response.json())
      .then((build) => {
        this.setState({ buildVersion: build.version })
      })
  }

  render() {
    return (
      <>
        &copy; {new Date().getFullYear()},  Clinical Reference Laboratory, Inc.
        {!location.host.includes("ontrack")  && <p>V {this.state.buildVersion}</p>}
      </>
    )
  }
}